/*
 * @Author: wyh
 * @Date: 2019-07-04 18:05:32
 * @Last Modified by: wyh
 * @Last Modified time: 2019-07-16 09:30:28
 * @Description: 本地城市服务接口
 */

import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { PinYinProvider } from "./city.pinyin.service";
import { FirstPINYIN, oMultiDiff } from "./city.pinyin";
import { CacheDataService } from "../../business/cache-data/cache-data.service";

const replaceParamsList = (root) => {
  const resNames = ["one", "two", "three", "four"];
  const result = [];
  const options = [[], [], [], [], []];
  const handleFind = (D, index, parentName) => {
    for (let i = 0; i < D.length; i++) {
      const d = D[i];
      const { children } = d;
      if (children && children.length) {
        delete d.children;
      }
      d["text"] = d.name == undefined ? null : d.name;
      d["value"] = `${d.id}-${d.name}`;
      d["parentVal"] = `${d.parentId}-${parentName}`;
      options[index].push(d);
      if (children && children.length) handleFind(children, index + 1, d.name);
    }
    result[index] = {
      name: resNames[index],
      parentCol: resNames[index - 1],
      options: options[index],
    };
  };
  handleFind(root, 0, "");
  return result;
};

@Injectable()
export class CityProvider {
  constructor(
    private pinyinProvider: PinYinProvider,
    private cacheDateSer: CacheDataService,
  ) {}

  public createMultiCitys(countryId, justLeaf = true): Promise<any> {
    return new Promise((resolve, reject) => {
      this.cacheDateSer.getInlandCitys(countryId).then(
        (citys) => {
          if (!citys) return reject(false);
          const multiSourceData = justLeaf ? citys.children : [citys];
          const coveLists = replaceParamsList(multiSourceData);
          console.log(coveLists);
          resolve(coveLists);
        },
        (err) => {
          reject(err);
        },
      );
    });
  }

  /**
   * 按照城市简拼／城市名称（汉字）查询
   * @param datas   城市数据
   * @param keyWord   关键字
   */
  searchCitys(datas, keyWord: string): Promise<any> {
    var filterCities = new Array();
    keyWord = keyWord.trim();
    // 判断关键字是汉字还是拼音，选择使用索引值查询
    var pinyinSearch = this.validateKeyword(keyWord);
    keyWord = pinyinSearch ? keyWord : keyWord.toUpperCase();
    console.log(keyWord);
    return new Promise(function (resolve, reject) {
      for (var item of datas) {
        for (var city of item.list) {
          var targetKeyWord = pinyinSearch ? city.name : city.code;
          if (targetKeyWord.indexOf(keyWord) == 0) {
            filterCities.push(city);
          }
        }
      }
      resolve(filterCities);
    });
  }

  /**
   * 校验输入的内容是中文？英文
   * @param entryVal
   * return true : 英文
   *        false : 中文
   */
  private validateKeyword(entryVal) {
    var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g"); // 汉字
    return reg.test(entryVal); // true: 汉字
  }

  /**
   * 生成城市数据，拼音和简拼
   * @param datas
   */
  private createCityDatas(datas) {
    var newCitys = [];
    for (var item of datas) {
      var newItem = {
        initial: "",
        list: [],
      };
      newItem.initial = item.initial;
      for (var city of item.list) {
        var newCity = {
          zip: "",
          name: "",
          pinyin: "",
          code: "",
        };
        newCity.zip = city.zip;
        newCity.name = city.name;
        newCity.pinyin = this.pinyinProvider
          .codefans_net_CC2PY(city.name)
          .toUpperCase();
        newCity.code = this.makePy(city.name)[0];
        newItem.list.push(newCity);
      }
      newCitys.push(newItem);
    }

    console.log(JSON.stringify(newCitys));
  }

  /**
   * 根据中文字符串生成简拼
   * @param str
   * @return :
   *    字符串数组
   */
  private makePy(str) {
    var arrResult = []; //保存中间结果的数组
    for (var i = 0, len = str.length; i < len; i++) {
      //获得unicode码
      var ch = str.charAt(i);
      //检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
      arrResult.push(this.checkCh(ch));
    }
    //处理arrResult,返回所有可能的拼音首字母串数组
    return this.mkRslt(arrResult);
  }

  private checkCh(ch) {
    var uni = ch.charCodeAt(0);
    //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
    if (uni > 40869 || uni < 19968) return ch; //dealWithOthers(ch);
    //检查是否是多音字,是按多音字处理,不是就直接在strChineseFirstPY字符串中找对应的首字母
    return oMultiDiff[uni] ? oMultiDiff[uni] : FirstPINYIN.charAt(uni - 19968);
  }

  private mkRslt(arr) {
    var arrRslt = [""];
    for (var i = 0, len = arr.length; i < len; i++) {
      var str = arr[i];
      var strlen = str.length;
      if (strlen == 1) {
        for (var k = 0; k < arrRslt.length; k++) {
          arrRslt[k] += str;
        }
      } else {
        var tmpArr = arrRslt.slice(0);
        arrRslt = [];
        for (k = 0; k < strlen; k++) {
          //复制一个相同的arrRslt
          var tmp = tmpArr.slice(0);
          //把当前字符str[k]添加到每个元素末尾
          for (var j = 0; j < tmp.length; j++) {
            tmp[j] += str.charAt(k);
          }
          //把复制并修改后的数组连接到arrRslt上
          arrRslt = arrRslt.concat(tmp);
        }
      }
    }
    return arrRslt;
  }

  /**
   * 异常处理类
   * @param error
   */
  public handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/services/common/city/city.service.ts